import(/* webpackMode: "eager" */ "/data/repos/bk-web-app_10a628/src/app/[locale]/bwbSwapBgb/page.tsx");
